<template>
  <div class="app-container">
    <el-card shadow="never" class="query-card">
      <el-form :model="query" ref="queryForm" :inline="true">
        <el-form-item label="账户ID" prop="adAccountId">
          <el-input
            v-model="query.adAccountId"
            placeholder="广告账户ID"
            clearable
            size="small"
            style="width: 200px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="关键字" prop="keyword">
          <el-input
            v-model="query.keyword"
            placeholder="系列名称 / 书名"
            clearable
            size="small"
            style="width: 240px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <el-row :gutter="10" class="mb8">
        <div class="right-tool">
          <el-tooltip effect="dark" content="刷新" placement="top">
            <el-button size="mini" circle icon="el-icon-refresh" @click="fetchList" />
          </el-tooltip>
        </div>
      </el-row>

      <el-table v-loading="loading" :data="tableData" border>
        <el-table-column label="广告账户ID" prop="adAccountId" width="180" :show-overflow-tooltip="true" />
        <el-table-column label="系列ID" prop="campaignId" width="200" :show-overflow-tooltip="true" />
        <el-table-column label="系列名称" prop="campaignName" min-width="280" :show-overflow-tooltip="true" />
        <el-table-column label="书名" prop="bookName" min-width="200" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.bookName">{{ scope.row.bookName }}</span>
            <span v-else style="color:#999">未解析</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" prop="updatedAt" width="180" align="center">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.updatedAt) }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          :current-page="pageNo"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { listCampaignBooks } from '@/api/dev/campaignBook'

export default {
  name: 'CampaignBookQuery',
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      pageNo: 1,
      pageSize: 20,
      query: {
        keyword: undefined,
        adAccountId: undefined
      }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          keyword: this.query.keyword || undefined,
          adAccountId: this.query.adAccountId || undefined
        }
        const response = await listCampaignBooks(params)
        this.tableData = response.data.records || []
        this.total = response.data.total || 0
      } finally {
        this.loading = false
      }
    },
    handleQuery() {
      this.pageNo = 1
      this.fetchList()
    },
    resetQuery() {
      this.query = { keyword: undefined, adAccountId: undefined }
      this.handleQuery()
    },
    handlePageChange(page) {
      this.pageNo = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.fetchList()
    },
    parseTime(time) {
      if (!time) return ''
      const normalized = typeof time === 'string' ? time.replace(' ', 'T') : time
      const date = new Date(normalized)
      if (Number.isNaN(date.getTime())) return String(time)
      var y = date.getFullYear()
      var m = (date.getMonth() + 1).toString().padStart(2, '0')
      var d = date.getDate().toString().padStart(2, '0')
      var h = date.getHours().toString().padStart(2, '0')
      var min = date.getMinutes().toString().padStart(2, '0')
      var s = date.getSeconds().toString().padStart(2, '0')
      return y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + s
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 0;
  background-color: #f8f8f9;
  min-height: calc(100vh - 84px);
}
.query-card {
  border: none;
}
.mb8 {
  margin-bottom: 8px;
}
.right-tool {
  float: right;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
